import React from "react";

class BatteryChartSingle extends React.Component {
    render() {
        return (
            <div className="d-flex flex-column mld-2 mt-1 w-100">
                {this.props.data.map((item, index) => {
                    return (
                        <div key={index} className="flexc">
                            {this.props.indicetor == true && (

                                <div className="flexc mld-2 mt-1 flex-1 " style={{ flexWrap: 'wrap', }}>
                                    {/* {item.map((item) => {
                                    return ( */}
                                    <div className="d-flex mrd-2 " >
                                        {/* <div className=" mld-2 mrd-1 mt-1">
                                            <div className="mrd-1" style={{ background: `${item.color}`, width: '11px', height: '11px', borderRadius: '100px', }} />
                                        </div> */}
                                        <div className="">
                                            <p style={{ color: this.props.colortext == true ? `${item.color}` : '#303030', fontWeight: 600 }}>{item.percent}</p>
                                            <p className="mld-1" style={{ color: '#303030', fontSize: 12 }}>{item.dce}</p>
                                        </div>
                                    </div>
                                    {/* )
                                    })
                                    } */}
                                </div>
                            )}

                            <div className="flex-3" style={{ overflow: 'hidden', borderRadius: this.props.borderRadius ?? 9, display: 'flex', background: '#eee', width: '100%', height: this.props.height ?? '30px' }}>
                                {/* {item.map((item) => {
                        return ( */}

                                <div className="flexcc" style={{ background: `${item.color}`, width: `${item.width}%`, height: this.props.height ?? '30px' }}>
                                    {/* <div className="flexcc">
                                                    <p style={{ color: "#252525" }}>
                                                        {item.percent}
                                                    </p>
                                                </div> */}
                                </div>
                                {/* )
                    })} */}

                            </div>

                        </div>
                    )
                })}
            </div>
        )
    }
}


export default BatteryChartSingle;